import { Card, Col, Row } from 'react-bootstrap';
import Meta from '../Components/Meta';
import BackButton from '../Components/BackButton';

const AboutScreen = () => {
  return (
    <>
      <BackButton />
      <Meta title="About Us | KCC Parts Distribution" />

      <section className="about-hero mb-5">
        <Row className="align-items-center g-4">
          <Col lg={6} className="about-fade-up">
            <p className="text-uppercase mb-2 about-eyebrow">
              About KCC Parts Distribution
            </p>
            <h1 className="mb-3">Reliable automotive parts, delivered with care.</h1>
            <p className="lead">
              KCC Parts Distribution is a Canadian supplier dedicated to quality
              and premium aftermarket parts. We help fleet managers and auto
              parts shops source the right components with fast delivery,
              fitment guidance, and responsive support.
            </p>
            <p>
              Our team focuses on accuracy, transparency, and long-term
              partnerships—so every order arrives on time and installs with
              confidence.
            </p>
            <div className="about-stats">
              <div>
                <span className="about-stat-value">48h</span>
                <span className="about-stat-label">Average fulfillment</span>
              </div>
              <div>
                <span className="about-stat-value">99%</span>
                <span className="about-stat-label">Fitment accuracy</span>
              </div>
              <div>
                <span className="about-stat-value">20K+</span>
                <span className="about-stat-label">Parts in stock</span>
              </div>
            </div>
          </Col>
          <Col lg={6} className="about-fade-right">
            <Card className="about-hero-card shadow-lg border-0">
              <Card.Img
                variant="top"
                src="DISTRIBUSTION.png"
                alt="KCC Parts Distribution warehouse and fulfillment"
                className="about-hero-image"
              />
              <Card.Body className="about-hero-body">
                <div>
                  <p className="text-uppercase text-muted small mb-1">
                    Distribution Center
                  </p>
                  <h4 className="mb-1">Monitored, packed, and shipped with care</h4>
                  <p className="mb-0">
                    Real-time inventory checks and dedicated fulfillment teams
                    keep your orders moving.
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </section>

      <Row className="g-4 about-section">
        <Col md={4} className="about-fade-up">
          <Card className="h-100 border-0 shadow-sm about-feature-card">
            <Card.Body>
              <h5>What we do</h5>
              <p className="mb-0">
                We stock and source high-quality brake, suspension, filtration,
                and engine components for most makes and models across Canada.
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="about-fade-up" style={{ animationDelay: '0.1s' }}>
          <Card className="h-100 border-0 shadow-sm about-feature-card">
            <Card.Body>
              <h5>How we support you</h5>
              <p className="mb-0">
                Our specialists verify fitment, provide quick quotes, and keep
                you informed from checkout to delivery.
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="about-fade-up" style={{ animationDelay: '0.2s' }}>
          <Card className="h-100 border-0 shadow-sm about-feature-card">
            <Card.Body>
              <h5>Why it matters</h5>
              <p className="mb-0">
                Accurate parts and dependable logistics mean fewer returns,
                faster installs, and happier customers.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="align-items-center mt-5 g-4 about-section">
        <Col lg={5} className="order-lg-2 about-fade-left">
          <Card className="shadow-sm border-0 about-image-card">
            <div >
              <Card.Img
                variant="top"
                src="installation.jpg"
                alt="Technicians preparing parts for installation"
                className="about-installation-image"
              />
            </div>
          </Card>
        </Col>
        <Col lg={7} className="order-lg-1 about-fade-up">
          <h2 className="mb-3">Installation-ready support for every order.</h2>
          <p>
            From single-bulk order to continuous fleet supply, KCC Parts
            Distribution adapts to your workflow. Our catalog continues to
            grow, and we invest in strong supplier relationships to secure
            dependable inventory.
          </p>
          <div className="about-process">
            <div>
              <h6>Verified fitment</h6>
              <p>
                Every item is checked against vehicle specs to minimize
                installation delays.
              </p>
            </div>
            <div>
              <h6>Installation guidance</h6>
              <p>
                Our team shares torque specs, hardware recommendations, and
                service notes when you need them.
              </p>
            </div>
            <div>
              <h6>Priority delivery</h6>
              <p>
                Optimized routing keeps high-urgency parts moving fast to your
                bay.
              </p>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="align-items-center mt-5 g-4">
        <Col lg={5} className="about-fade-up">
          <Card className="shadow-sm border-0 about-image-card">
            <Card.Img
              variant="top"
              src="/inspection.png"
              alt="Team member inspecting automotive parts"
              className="about-hero-image"
            />
          </Card>
        </Col>
        <Col lg={7} className="about-fade-up" style={{ animationDelay: '0.1s' }}>
          <h2 className="mb-3">Built for professionals, trusted by drivers.</h2>
          <p>
            Your success is our priority. We bring clarity to complex catalogs
            and communicate proactively, so you can plan installs and keep
            customers satisfied.
          </p>
          <p className="mb-0">
            Need help selecting parts or planning a bulk order? Our team is
            ready to assist with quotes, cross-references, and product
            recommendations.
          </p>
        </Col>
      </Row>
    </>
  );
};

export default AboutScreen;
